module.exports = __webpack_public_path__ + "img/bj-img.68851571.png";